"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var constants_1 = require("../../../constants");
var inputTag_1 = __importDefault(require("../../atoms/inputTag"));
var SvgSpriteLoader_1 = __importDefault(require("../SvgSpriteLoader"));
var SIZES = {
    LARGE: 'LARGE',
    MEDIUM: 'MEDIUM',
    SMALL: 'SMALL',
    SMALLEST: 'SMALLEST',
};
var sizeClass = (_a = {},
    _a[SIZES.LARGE] = {
        inputClassBySize: 'tw-h-[72px] tw-py-[24px] tw-pl-[64px] tw-pr-[58px]',
        inputClassWithoutIcons: 'tw-h-[72px] tw-p-[24px]',
        inputClassWithoutLeadingIcon: 'tw-h-[72px] tw-py-[24px] tw-pl-[24px] tw-pr-[58px]',
        inputClassWithoutTrailingIcon: 'tw-h-[72px] tw-py-[24px] tw-pl-[64px] tw-pr-[24px]',
        leadingIconClassBySize: 'tw-left-[24px] tw-w-[24px] tw-h-[24px]',
        trailingIconClassBySize: 'tw-right-[24px] tw-w-[24px] tw-h-[24px]',
        inputFontClassName: 'f-16-300',
    },
    _a[SIZES.MEDIUM] = {
        inputClassBySize: 'tw-h-[52px] tw-py-[16px] tw-pl-[60px] tw-pr-[54px]',
        inputClassWithoutIcons: 'tw-h-[52px] tw-py-[16px] tw-px-[24px] ',
        inputClassWithoutLeadingIcon: 'tw-h-[52px] tw-py-[16px] tw-pl-[24px] tw-pr-[54px]',
        inputClassWithoutTrailingIcon: 'tw-h-[52px] tw-py-[16px] tw-pl-[60px] tw-pr-[24px]',
        leadingIconClassBySize: 'tw-left-[24px] tw-w-[20px] tw-h-[20px]',
        trailingIconClassBySize: 'tw-right-[24px] tw-w-[20px] tw-h-[20px]',
        inputFontClassName: 'f-16-300',
    },
    _a[SIZES.SMALL] = {
        inputClassBySize: 'tw-h-[44px] tw-py-[12px] tw-pl-[56px] tw-pr-[50px]',
        inputClassWithoutIcons: 'tw-h-[44px] tw-py-[12px] tw-px-[24px]',
        inputClassWithoutLeadingIcon: 'tw-h-[44px] tw-py-[12px] tw-pl-[24px] tw-pr-[50px]',
        inputClassWithoutTrailingIcon: 'tw-h-[44px] tw-py-[12px] tw-pl-[56px] tw-pr-[24px]',
        leadingIconClassBySize: 'tw-left-[24px] tw-w-[16px] tw-h-[16px]',
        trailingIconClassBySize: 'tw-right-[24px] tw-w-[16px] tw-h-[16px]',
        inputFontClassName: 'f-16-300',
    },
    _a[SIZES.SMALLEST] = {
        inputClassBySize: 'tw-h-[27px] tw-py-1.5 tw-pl-2 tw-pr-[30px]',
        inputClassWithoutIcons: 'tw-h-[27px] tw-py-1.5 tw-px-2',
        inputClassWithoutLeadingIcon: 'tw-h-[27px] tw-py-1.5 tw-pl-1.5 tw-pr-[30px]',
        inputClassWithoutTrailingIcon: 'tw-h-[27px] tw-py-1.5 tw-pl-2 tw-pr-2',
        leadingIconClassBySize: 'tw-left-2 tw-w-3 tw-h-3',
        trailingIconClassBySize: 'tw-right-2 tw-w-3 tw-h-3',
        inputFontClassName: 'f-12-300',
    },
    _a);
var InputField = function (_a) {
    var _b = _a.size, size = _b === void 0 ? SIZES.LARGE : _b, inputTagProps = _a.inputTagProps, _c = _a.showLeadingIcon, showLeadingIcon = _c === void 0 ? false : _c, _d = _a.showTrailingIcon, showTrailingIcon = _d === void 0 ? false : _d, _e = _a.leadingIconClass, leadingIconClass = _e === void 0 ? 'tw-absolute tw-flex tw-justify-center tw-items-center' : _e, _f = _a.trailingIconClass, trailingIconClass = _f === void 0 ? 'tw-absolute tw-flex tw-justify-center tw-items-center' : _f, _g = _a.inputFieldWrapperClass, inputFieldWrapperClass = _g === void 0 ? 'tw-flex tw-items-center tw-relative ' : _g, _h = _a.handleLeadingAction, handleLeadingAction = _h === void 0 ? constants_1.defaultFn : _h, _j = _a.handleTrailingAction, handleTrailingAction = _j === void 0 ? constants_1.defaultFn : _j, _k = _a.leadingIconProps, leadingIconProps = _k === void 0 ? {} : _k, _l = _a.trailingIconProps, trailingIconProps = _l === void 0 ? {} : _l, id = _a.id;
    var _m = sizeClass[size], inputClassBySize = _m.inputClassBySize, inputClassWithoutIcons = _m.inputClassWithoutIcons, inputClassWithoutLeadingIcon = _m.inputClassWithoutLeadingIcon, inputClassWithoutTrailingIcon = _m.inputClassWithoutTrailingIcon, leadingIconClassBySize = _m.leadingIconClassBySize, trailingIconClassBySize = _m.trailingIconClassBySize;
    var inputSizeClass = showLeadingIcon && showTrailingIcon
        ? inputClassBySize
        : showLeadingIcon
            ? inputClassWithoutTrailingIcon
            : showTrailingIcon
                ? inputClassWithoutLeadingIcon
                : inputClassWithoutIcons;
    var leadingIconSizeClass = leadingIconClass + " " + leadingIconClassBySize;
    var trailingIconSizeClass = trailingIconClass + " " + trailingIconClassBySize;
    return (react_1.default.createElement("div", { className: inputFieldWrapperClass, "data-testid": "input-field-" + id },
        showLeadingIcon && (leadingIconProps === null || leadingIconProps === void 0 ? void 0 : leadingIconProps.id) && (leadingIconProps === null || leadingIconProps === void 0 ? void 0 : leadingIconProps.iconCategory) && (react_1.default.createElement("div", { className: leadingIconSizeClass, role: 'button', onClick: handleLeadingAction, "data-testid": "input-field-leading-icon-wrapper" + id },
            react_1.default.createElement(SvgSpriteLoader_1.default, __assign({ id: leadingIconProps === null || leadingIconProps === void 0 ? void 0 : leadingIconProps.id, iconCategory: leadingIconProps === null || leadingIconProps === void 0 ? void 0 : leadingIconProps.iconCategory }, leadingIconProps)))),
        react_1.default.createElement(inputTag_1.default, __assign({ inputSizeClass: inputSizeClass, inputFontClassName: sizeClass[size].inputFontClassName }, inputTagProps)),
        showTrailingIcon && (trailingIconProps === null || trailingIconProps === void 0 ? void 0 : trailingIconProps.id) && (trailingIconProps === null || trailingIconProps === void 0 ? void 0 : trailingIconProps.iconCategory) && (react_1.default.createElement("div", { className: trailingIconSizeClass, role: 'button', onClick: handleTrailingAction, "data-testid": "input-field-trailing-icon-wrapper-" + id },
            react_1.default.createElement(SvgSpriteLoader_1.default, __assign({ id: trailingIconProps === null || trailingIconProps === void 0 ? void 0 : trailingIconProps.id, iconCategory: trailingIconProps === null || trailingIconProps === void 0 ? void 0 : trailingIconProps.iconCategory }, trailingIconProps))))));
};
exports.default = react_1.memo(InputField);
